"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _LanguageSelectModal = require("./LanguageSelectModal");
Object.keys(_LanguageSelectModal).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LanguageSelectModal[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _LanguageSelectModal[key];
    }
  });
});
var _Loading = require("./Loading");
Object.keys(_Loading).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Loading[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Loading[key];
    }
  });
});
